/**
 * Static add-to-cart bar for the product-list mobile carousel.
 * Shows one add-to-cart form at a time, synced to the active carousel
 * slide via the bubbling `slideshow:select` event.
 */
class CarouselStaticAtc extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  /** @param {Event & {detail?: {index?: number}}} event */
  #onSlideSelect = (event) => {
    const index = event.detail?.index;
    if (typeof index !== 'number') return;

    for (const item of this.querySelectorAll('.product-list-static-atc__item')) {
      item.toggleAttribute('hidden', Number(item.getAttribute('data-slide-index')) !== index);
    }
  };

  connectedCallback() {
    this.#section = this.closest('.section-resource-list');
    this.#section?.addEventListener('slideshow:select', this.#onSlideSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener('slideshow:select', this.#onSlideSelect);
    this.#section = null;
  }
}

if (!customElements.get('carousel-static-atc')) {
  customElements.define('carousel-static-atc', CarouselStaticAtc);
}
